import React from 'react';
import Layout from '../../Components/Common/Layout';
import Credits from '../../Components/Credits';

const CreditsPage = () => {
  return (
    <Layout title={'credits'}>
      <Credits />
    </Layout>
  );
};

export default CreditsPage;
